import { DataProvider, Record } from 'react-admin'

const fakeTechnicalAssistanceProtocols: Record[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({
      data: fakeTechnicalAssistanceProtocols,
      total: fakeTechnicalAssistanceProtocols.length,
    }),
} as DataProvider

export default provider
